<template>
    <div class="modal-content">
        <slot></slot>
    </div>
</template>
